import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { GetCaseListBo } from './case-manager.model';
import { ErrorService } from 'src/app/service/error.service';
import { DataStateChangeEventArgs } from '@syncfusion/ej2-angular-grids';
import { Subject } from 'rxjs/Subject';

import { GlobalComponent } from 'src/app/global/global.component';
import { GeneralService } from 'src/app/service/general.service';
import { NgxUiLoaderService } from 'ngx-ui-loader';
@Injectable()

export class GetHTTPService extends Subject<DataStateChangeEventArgs>{
  constructor(private http: HttpClient, public errorService: ErrorService, private ngxService: NgxUiLoaderService, public global: GlobalComponent, public general: GeneralService) {
    super();
  }

  public execute(state: GetCaseListBo): void {
    this.getCaseList(state).subscribe(x => super.next(x));
    this.ngxService.stop()
  }
  getCaseList(state?: GetCaseListBo): Observable<DataStateChangeEventArgs> {
    return this.http.post<any>("api/CaseManager/GetCaseManagerListFilter?", state)
      .pipe(map(
        (response: any) =>
          <any>{
            result: response['result'],
            count: response['count']
          })).pipe(map((e: any) => {

            e.result.forEach(element => {
              element.phone = element.phone != null ? this.general.reconverPhoneGoogleLibhttpsave(element.phone) : null;
              element.fax = element.fax != null ? this.general.reconverPhoneGoogleLibhttpsave(element.fax) : null;
            })
            return e;
          })
          )
  }
}
